import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LivePopupComponent } from './live-popup.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ LivePopupComponent ],
    declarations: [ LivePopupComponent ],
})
export class LivePopupModule {}
